export default {"src":"/_next/static/media/laos.ca2f07ec.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};